import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import { Button, Typography } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import DraftTable from "./DraftTable";
import TenderTable from "./TenderTable";
import axios from "axios";
import VQTable from "./VQTable";
import ItemCount from "../../utils/ItemCount";

const BuyerDashboard = () => {
  const [tenders, setTenders] = useState();
  const [vq, setVq] = useState();
  const [draft, setDraft] = useState(false);
  const storedUser = JSON.parse(localStorage.getItem("user"));
  const [activeTab, setActiveTab] = useState(localStorage.getItem("activeTab") || "REVIEW");
  const [isLoading, setIsLoading] = useState(true);
  const [isVQLoading, setIsVQLoading] = useState(true);
  const [pendingActions, setPendingActions] = useState(false);
  const navigate = useNavigate();
  const [reviewCount, setReviewCount] = useState(0);
  const [approvedCount, setApprovedCount] = useState(0);
  const [reworkCount, setReworkCount] = useState(0);
  const [rejectCount, setRejectCount] = useState(0);
  const [concludedCount, setConcludedCount] = useState(0);
  const [draftCount, setDraftCount] = useState(0);

  useEffect(() => {
    const getReviewCount = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/tender/item?username=${storedUser.username}&status=REVIEW`,
          { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
        );
        setReviewCount(res.data);
      } catch (error) {
        console.log(error);
      }
    };
    getReviewCount();

    const getApprovedCount = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/tender/item?username=${storedUser.username}&status=PROGRESS`,
          { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
        );
        setApprovedCount(res.data);
      } catch (error) {
        console.log(error);
      }
    };
    getApprovedCount();

    const getReworkCount = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/tender/item?username=${storedUser.username}&status=REWORK`,
          { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
        );
        setReworkCount(res.data);
      } catch (error) {
        console.log(error);
      }
    };
    getReworkCount();

    const getRejectCount = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/tender/item?username=${storedUser.username}&status=REJECTED`,
          { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
        );
        setRejectCount(res.data);
      } catch (error) {
        console.log(error);
      }
    };
    getRejectCount();

    const getConcludedCount = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/tender/item?username=${storedUser.username}&status=AWARDED`,
          { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
        );
        setConcludedCount(res.data);
      } catch (error) {
        console.log(error);
      }
    };
    getConcludedCount();
    const getDraftCount = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/draft/item?username=${storedUser.username}`,
          { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
        );
        setDraftCount(res.data);
      } catch (error) {
        console.log(error);
      }
    };
    getDraftCount();
  }, []);

  const handleInDrafts = async () => {
    setDraft(true);
    setIsLoading(true);
    setActiveTab("drafts");
  };

  useEffect(() => {
    if (activeTab !== "drafts" && activeTab !== "VQ") {
      const getTenders = async () => {
        setTenders();
        try {
          const res = await axios.get(
            `${process.env.REACT_APP_BACKEND_URL}/tender?username=${storedUser.username}&status=${activeTab}`,
            { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
          );
          setTenders(res.data);
          setIsLoading(false);
          localStorage.removeItem("activeTab")
        } catch (error) {
          console.log(error);
        }
      };
      getTenders();
    }
  }, [activeTab]);

  const getVendorTenders = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/vendor-tender/org?username=${storedUser.username}`,
        { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
      );
      setVq(res.data);
      setIsVQLoading(false);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    if (activeTab === "VQ") {
      getVendorTenders();
    }
  }, [activeTab]);

  useEffect(() => {
    if (localStorage.getItem("pending")) {
      setActiveTab("VQ");
      setPendingActions(true);
      localStorage.removeItem("pending");
    }
  }, []);

  return (
    <Box sx={{ textAlign: "center" }}>
      {/* <h1>Dashboard ({storedUser && storedUser.userRole[0]})</h1> */}
      {storedUser && storedUser.userRole.includes("BUYER") && (
        <Box sx={{ display: "flex", justifyContent: "end" }}>
          <Link to={"/dashboard/create-tender"}>
            <Button className="btn-contained" sx={{ px: 5 }}>
              + New Tender
            </Button>
          </Link>
        </Box>
      )}

      <Box className="dashboard-container" sx={{ height: 400, width: "100%" }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            mb: 2,
            borderBottom: "1px solid #D1D1D1",
          }}
        >
          <Box
            sx={{
              display: "flex",
              gap: 1,
            }}
          >
            <Button
              className={`dashboard-btns ${
                activeTab === "REVIEW" ? "active" : ""
              }`}
              onClick={() => {
                setDraft(false);
                setActiveTab("REVIEW");
                setIsLoading(true);
              }}
            >
              Under Review <ItemCount count={reviewCount} />
            </Button>
            <Button
              className={`dashboard-btns ${
                activeTab === "PROGRESS" ? "active" : ""
              }`}
              onClick={() => {
                setDraft(false);
                setActiveTab("PROGRESS");
                setIsLoading(true);
              }}
            >
              In Progress <ItemCount count={approvedCount} />
            </Button>
            <Button
              className={`dashboard-btns ${
                activeTab === "REJECTED" ? "active" : ""
              }`}
              onClick={() => {
                setDraft(false);
                setActiveTab("REJECTED");
                setIsLoading(true);
              }}
            >
              Rejected <ItemCount count={rejectCount} />
            </Button>
            <Button
              className={`dashboard-btns ${
                activeTab === "drafts" ? "active" : ""
              }`}
              onClick={handleInDrafts}
            >
              My Drafts <ItemCount count={draftCount} />
            </Button>
            <Button
              className={`dashboard-btns ${
                activeTab === "REWORK" ? "active" : ""
              }`}
              onClick={() => {
                setDraft(false);
                setActiveTab("REWORK");
                setIsLoading(true);
              }}
            >
              Rework <ItemCount count={reworkCount} />
            </Button>
            <Button
              className={`dashboard-btns ${
                activeTab === "AWARDED" ? "active" : ""
              }`}
              onClick={() => {
                setDraft(false);
                setActiveTab("AWARDED");
                setIsLoading(true);
              }}
            >
              Concluded <ItemCount count={concludedCount} />
            </Button>
          </Box>
          <Box>
            <Button
              className="pending-btn"
              onClick={() => {
                navigate("/dashboard/pending-actions")
                setActiveTab("VQ");
              }}
            >
              My Pending actions
            </Button>
          </Box>
        </Box>
        {draft ? (
          <DraftTable />
        ) : (
          <TenderTable
            tenders={tenders}
            activeTab={activeTab}
            isLoading={isLoading}
          />
        )}
      </Box>
    </Box>
  );
};

export default BuyerDashboard;
